export const BROWSER_SUPPORT = {
	chrome: true,
	firefox: true,
	safari: false,
	edge: false,
	opera: false,
	samsung: false,
	other: false,
};

export const BROWSER_LABELS = {
	chrome: "Google Chrome",
	firefox: "Mozilla Firefox",
	safari: "Apple Safari",
	edge: "Microsoft Edge",
	opera: "Opera",
	samsung: "Samsung Internet",
	other: "Unsupported Browser",
};

export const detectBrowser = (uaInput) => {
	const ua = String(uaInput || window.navigator.userAgent || "").toLowerCase();
	if (/firefox|fxios/.test(ua)) return "firefox";
	if (/edg\//.test(ua)) return "edge";
	if (/opr\//.test(ua)) return "opera";
	if (/samsungbrowser/.test(ua)) return "samsung";
	if (/safari/.test(ua) && !/chrome|crios|android/.test(ua)) return "safari";
	if (/chrome|crios/.test(ua)) return "chrome";
	return "other";
};

export const isBrowserSupported = (uaInput) => {
	const browserKey = detectBrowser(uaInput);
	return BROWSER_SUPPORT[browserKey] === true;
};
